/**
 * Open a safe fallback tab when the acknowledged cross-app relay is unavailable.
 *
 * Existing-tab reuse belongs exclusively to peer navigation. A cross-origin
 * sender cannot safely navigate an unrelated named browsing context: browsers
 * reject it unless the target is the sender's parent or opener.
 */
export function openFallbackWindow(url: string): void {
    window.open(url, "_blank", "noopener,noreferrer");
}
